import { registerLocaleData } from '@angular/common';
import localeEl from '@angular/common/locales/el';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './modules/core/core.module';
import { SharedModule } from './modules/shared/shared.module';
import { MockDataService } from './services/mock/mock.service';

registerLocaleData(localeEl);

const mockImports = environment.useMock
  ? [HttpClientInMemoryWebApiModule.forRoot(MockDataService, {
    delay: 500, // Reduced delay for better development experience
    passThruUnknownUrl: true, // Allows real HTTP requests for other URLs
  })]
  : [];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    ...mockImports,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'el' },
    {
      provide: 'appName',
      useValue: environment.appTitle,
    },
    {
      provide: 'apiUrl',
      useValue: environment.apiUrl,
    },
    {
      provide: 'apiAppVersion',
      useValue: environment.appVersion,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
